import React from 'react'
import "./HomeText.css"

function HomeText() {
  return (
    <div className='home-text'>
      <h1>Hotel Relax</h1>
    </div>
  )
}

export default HomeText
